export const Fireplace = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M17 9.143a7.231 7.231 0 00-3.225-5.927 1.163 1.163 0 00-1.818 1.143c.15.978-.09 1.976-.667 2.78a3.884 3.884 0 01-1.056-1.544.756.756 0 00-1.117-.418A4.796 4.796 0 007.04 9.766 5.012 5.012 0 0017 9.143z'
          clipRule='evenodd'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M4 21l17-6M8 16.412L4 15M17 19.588L21 21'
        ></path>
      </svg>
    </span>
  );
};
